import React, { useState, useEffect, useRef } from 'react';
import { CircularProgress, Button, Card, Divider, IconButton, Modal, Typography, Grid, Box, Slider, Fade } from '@mui/material';
import { ArrowDropDown, Close } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import IconTint from 'react-icon-tint';
import ProgressBar from "react-customizable-progressbar";
import { Container, Title, Accordion, rem, createStyles } from '@mantine/core';

import { CheckCircle, Circle, AlertTriangle } from 'lucide-react';
import { getUserDetails } from '../Auth/AuthUtil';
import awlogo from "../Assets/images/Group 16808.png";
import Dialog from '@mui/material/Dialog';
import { profileModel } from '../Axios/AxiosConfig';
import unqimage from '../Assets/images/uqvector.png'
import DialogTitle from '@mui/material/DialogTitle';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import tipsIcon from '../Assets/images/Tips.png';
import vikritinext from '../Assets/images/vikritinext.png'
import RoutineIcon from '../Assets/images/Routine.png';
import FoodIcon from '../Assets/images/Food.png';
import ReportIcon from '../Assets/images/tabler-icon-file-description.png'
import ReportStore from '../DataRepo/ReportStore';
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import AppointmentStore from '../DataRepo/AppointmentStore';

const StrengthSlider = ({ dietList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % dietList.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [dietList]);

  const currentDiet = dietList[currentIndex];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className='Strength-page'>
      <div className='flex flex-row justify-between items-center Strength-page-title'>
        <p>STRENGTH</p>
        <IconButton onClick={handleOpen}>
          <KeyboardArrowDownOutlinedIcon />
        </IconButton>
      </div>
      <div className='Strength-card'>
        <div>
          <img src={currentDiet?.imgsrc} alt={currentDiet?.name} />
        </div>
        <div>
          <p>{currentDiet?.name}</p>
        </div>
      </div>
      <Dialog open={open} onClose={handleClose} fullWidth>
        <div className='Strength-popup'>
          <p>Strength</p>
          <div >
            {dietList.map((diet, index) => (
              <div key={index} className='Strength-popup-item flex flex-col items-center justify-center'>
                <div>
                  <img src={diet.imgsrc} alt={diet.name} />
                </div>
                <div><p>{diet?.name}</p></div>
              </div>
            ))}
          </div>
        </div>
      </Dialog>
    </div>
  );
};

const WeaknessSlider = ({ dietList }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % dietList.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [dietList]);

  const currentDiet = dietList[currentIndex];
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);



  return (
    <div className='Strength-page' >
      <div className='flex flex-row justify-between items-center Strength-page-title'>
        <p>WEAKNESS</p>
        <IconButton onClick={handleOpen}><KeyboardArrowDownOutlinedIcon /></IconButton>
      </div>
      <div className='Strength-card'>
        <div>
          <img src={currentDiet?.imgsrc} alt={currentDiet?.name} />
        </div>
        <div >
          <p>{currentDiet?.name}</p>
        </div>
      </div>

      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
        <div className='Strength-popup'>
          <p>Weakness</p>
          <div >
            {dietList.map((diet, index) => (
              <div key={index} className='Strength-popup-item flex flex-col items-center justify-center'>
                <div><img src={diet.imgsrc} alt={diet.name} /></div>
                <div><p>{diet.name}</p></div>
              </div>
            ))}
          </div>
        </div>
      </Dialog>

    </div>
  );

};

const BulletTextGrid = ({ textList }) => (
  <div
    className="Susceptible_disorders rounded-md bg-[#F9F9F6] shadow-md"
    style={{

      fontFamily: "'Poppins', sans-serif",
      fontWeight: 400,
    }}
  >
    <div className="rounded-t-md mb-2 p-2" style={{ fontWeight: 500 }}>
      <p>Susceptible Health Issues</p>
    </div>

    <ul className="p-5 space-y-1 overflow-y-auto m-5 mb-0 mt-0" style={{ maxHeight: "150px", overflowY: "auto" }}>
      {textList.map((text, index) => (
        <li key={index}>
          {text.charAt(0).toUpperCase() + text.slice(1)}
        </li>
      ))}
    </ul>
  </div>

);

const TasteItem = ({ taste, imageUrl, bgColor, iconColor }) => {
  const textRef = useRef(null);
  const [overflow, setOverflow] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      const isOverflowing = textRef.current.scrollWidth > textRef.current.clientWidth;
      setOverflow(isOverflowing);
    }
  }, [taste]);

  return (
    <div
      className={`py-2 px-2 mb-2 rounded-md text-sm flex gap-2 items-center`}
      style={{
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 400,
        backgroundColor: bgColor,
        color: '#3B362A'
      }}
    >
      <div className='w-10 h-10 bg-[#FDFDFD] rounded-full  inline-flex items-center justify-center' style={{ flex: "0.5, width: '2.5rem', height: '2.5rem'}}>" }}>
        <IconTint src={imageUrl} color={iconColor} className='w-6 h-6' />
      </div>
      <div className="flex-1 overflow-hidden relative w-full">
        <p
          ref={textRef}
          className={overflow ? 'marquee' : 'truncate'}
        >
          {taste}
        </p>
      </div>
    </div>
  );
};

const PreConsultationSummary = ({ prakritiState, prakritiResultState }) => {

  const [showButton, setShowButton] = useState(false);

  const [strengthSheetOpen, setStrengthSheetOpen] = useState(false);

  const [weaknessSheetOpen, setWeaknessSheetOpen] = useState(false);

  const [isLoading, setLoading] = useState(true);

  const [prakritiData, setPrakritiData] = useState([]);

  const [prakritiresultData, setPrakritiResultData] = useState([]);

  const { getAppointments, Appointments } = AppointmentStore();

  const navigate = useNavigate();

  const { state } = useLocation();

  const [diseases, setDiseases] = useState([])

  const { getAIReports, AIReports, isAIReportsLoading } = ReportStore();

  const userDetails = getUserDetails();

  const [vikritiData, setvikritiData] = useState([])

  const fetchPrakritiResult = async (result) => {
    try {
      let res = await profileModel.post(`/fetchPrakritiResult`, {
        result
      });

      if (res.status === 200) {
        setPrakritiResultData(res.data)
        setLoading(false)
      }

    } catch (err) {
      console.log(err?.response?.data);
    }
  }

  const getPrakritiData = async () => {
    try {
      let res = await profileModel.get(`/GetPrakritidata/${userDetails.UID}`);
      if (res.status === 200) {
        fetchPrakritiResult(res.data.result)
        setPrakritiData(res.data)
      }
    } catch (err) {
      console.log(err?.response?.data);
    }
  };

  const getvikritiData = async () => {
    try {
      let res = await profileModel.get(`/Vikriti/${userDetails.UID}`);
      if (res.status === 200) {

        setvikritiData(res.data)
      }
    } catch (err) {
      console.log(err?.response?.data);
    }
  };

  const getdisease = async () => {
    try {

      const res = await profileModel.get(`/Disease/${userDetails?.UID}`);

      const { diseaseList } = res?.data;

      setDiseases(diseaseList);

    } catch (err) {
      console.error("error", err);
    }
  };

  useEffect(() => {
    getPrakritiData()
    getdisease()
    getvikritiData()
  }, []);

  const handleScroll = (event) => {
    setShowButton(event.target.scrollTop > 100);
  };

  function getPrakritiGuidance(prakriti) {

    const key = prakriti?.trim()?.toLowerCase();

    switch (key) {
      case "v":
        return {
          positiveTraits: "Creative, energetic, adaptable, quick thinker.",
          routine: "Follow a steady, timely schedule; prioritize rest.",
          food: "Warm, oily and mildly spiced nourishing meal. Soft and easy to digest dishes like soups, stews & porridge.",
          techTip: "Set hydration + meal time alerts to avoid skipping food."
        };
      case "p":
        return {
          positiveTraits: "Focused, intelligent, brave, decisive.",
          routine: "Avoid working during the hottest part of the day.",
          food: "Cool, slightly heavy foods.",
          techTip: "Set cooling break reminders mid-day (e.g., stretch + splash face)."
        };
      case "k":
        return {
          positiveTraits: "Nurturing, patient, loyal, strong immunity",
          routine: "Rise before 6 AM; energize early with movement.",
          food: "Light, dry, spicy and warm foods.",
          techTip: "Use “Move Every 60 Min” alert."
        };
      case "vp":
        return {
          positiveTraits: "Innovative, driven, quick learner, expressive",
          routine: "Balance activity with relaxation. Keep calm and avoid overexertion.",
          food: "Mild warm but not too spicy.",
          techTip: "Alternate reminders: “Breathe + Hydrate” / “Wind Down @9 PM”."
        };
      case "vk":
        return {
          positiveTraits: "Imaginative, gentle, empathetic, artistic",
          routine: "Start slow but energize by mid-morning; avoid naps.",
          food: "Warm, light soups and teas; avoid cold, heavy meals.",
          techTip: "Install blue light filters in phone and computers to reduce eye strain."
        };
      case "pv":
        return {
          positiveTraits: "Visionary, passionate, analytical, dynamic",
          routine: "Keep cool and focused, protect from over stimulation.",
          food: "Cooked, mildly spiced vegetables and grains.",
          techTip: "Set a screen time reminder to gently get breaks for every hour."
        };
      case "pk":
        return {
          positiveTraits: "Strong-willed, dependable, excellent memory, determined",
          routine: "Balance intensity with movement; avoid sleep-in.",
          food: "Prefer steamed vegetables with less spices. Avoid heavy, fried foods and large late dinners.",
          techTip: "Set reminders for the day: “Energize,” “Digest,” “Reset”."
        };
      case "kv":
        return {
          positiveTraits: "Kind-hearted, intuitive, steady with creative sparks",
          routine: "Active mornings, early dinners, consistent sleep times.",
          food: "Light, warm, mildly spiced; avoid large late meals.",
          techTip: "“Stretch & Express” — stretching or walking and do creative activities."
        };
      case "kp":
        return {
          positiveTraits: "Loyal, strategic, balanced leader, emotionally intelligent",
          routine: "Early rising, avoid oversleeping; wind down gradually.",
          food: "Dry, light food and favour warm herbal teas.",
          techTip: "“Lighten up and let go.” Walk, listen to music, or take a deep breath."
        };
      case "vpk":
        return {
          positiveTraits: "Balanced, versatile, adaptable, harmonious, resilient",
          routine: "Follow nature’s rhythm—Rise early and sunset aligned.",
          food: "Balanced variety of all six tastes in moderation.",
          techTip: "Limit screen time and do meditation for calm mind."
        };
      case "vkp":
        return {
          positiveTraits: "Artistic, compassionate, grounded with spark, imaginative but steady",
          routine: "Stimulate morning, creative mid-day break, early wind down.",
          food: "Easy-to-digest and warm foods.",
          techTip: "Focus on one task at a time to stay calm and avoid feeling sluggish."
        };
      case "pvk":
        return {
          positiveTraits: "Assertive, strategic thinker, energized and quick learner",
          routine: "Avoid overwork and focus work with relaxation.",
          food: "Eat cool, hydrating foods like cucumbers. Avoid spicy, oily, and heavy foods.",
          techTip: "Incorporate mindful pauses to restore mental clarity."
        };
      case "pkv":
        return {
          positiveTraits: "Resilient, composed leader, emotionally intelligent",
          routine: "Begin with purpose, avoid overloading, reset mid-day.",
          food: "Choose bitter greens and legumes; eat light, avoid heavy food.",
          techTip: "Do creative activities like drawing, writing to keep mind calm and avoid restlessness."
        };
      case "kvp":
        return {
          positiveTraits: "Empathetic, intuitive, calm with bursts of inspiration, stable thinker.",
          routine: "Start your day early with warm water and movement, eat light meals, and keep active throughout. Wind down with an early dinner and sleep.",
          food: "Fresh, vibrant, light warm meals with gentle spice.",
          techTip: "Nature walk reminders + 2-min “mind-clearing” alerts to prevent sluggishness and mental fatigue."
        };
      default:
        return {
          positiveTraits: '',
          routine: '',
          food: '',
          techTip: '',
        };
    }
  };

  function getTasteData(prakriti) {
    const tasteData = {
      v: {
        suitable: ["Sweet", "Sour", "Salty"],
        avoid: ["Bitter", "Pungent", "Astringent"]
      },
      p: {
        suitable: ["Sweet", "Bitter", "Astringent"],
        avoid: ["Sour", "Salty", "Pungent"]
      },
      k: {
        suitable: ["Pungent", "Bitter", "Astringent"],
        avoid: ["Sweet", "Sour", "Salty"]
      },
      vp: {
        suitable: ["Sweet", "Bitter", "Small amount of Sour"],
        avoid: ["Pungent", "Astringent", "Salty"]
      },
      pv: {
        suitable: ["Sweet", "Bitter", "Small amount of Sour"],
        avoid: ["Pungent", "Astringent", "Salty"]
      },
      vk: {
        suitable: ["Pungent", "Sour", "Bitter"],
        avoid: ["Sweet", "Salty", "Astringent"]
      },
      kv: {
        suitable: ["Pungent", "Sour", "Bitter"],
        avoid: ["Sweet", "Salty", "Astringent"]
      },
      pk: {
        suitable: ["Bitter", "Astringent", "Pungent"],
        avoid: ["Sweet", "Sour", "Salty"]
      },
      kp: {
        suitable: ["Bitter", "Astringent", "Pungent"],
        avoid: ["Sweet", "Sour", "Salty"]
      },
      vpk: {
        suitable: ["All tastes (Sweet, Sour, Salty, Pungent, Bitter, Astringent) in moderation"],
        avoid: ["Excess of any one taste"]
      },
      vkp: {
        suitable: ["All tastes (Sweet, Sour, Salty, Pungent, Bitter, Astringent) in moderation"],
        avoid: ["Excess of any one taste"]
      },
      pvk: {
        suitable: ["All tastes (Sweet, Sour, Salty, Pungent, Bitter, Astringent) in moderation"],
        avoid: ["Excess of any one taste"]
      },
      pkv: {
        suitable: ["All tastes (Sweet, Sour, Salty, Pungent, Bitter, Astringent) in moderation"],
        avoid: ["Excess of any one taste"]
      },
      kvp: {
        suitable: ["All tastes (Sweet, Sour, Salty, Pungent, Bitter, Astringent) in moderation"],
        avoid: ["Excess of any one taste"]
      }
    };

    const key = prakriti?.trim()?.toLowerCase();
    return tasteData[key] || { suitable: [], avoid: [] };
  };

  const { suitable, avoid } = getTasteData(prakritiData?.result)

  const { positiveTraits, routine, food, techTip } = getPrakritiGuidance(prakritiData?.result);

  function getDoshaName(doshaCode) {
    if (!doshaCode) return "";
    const doshaMap = {
      v: "Vata",
      p: "Pitta",
      k: "Kapha"
    };

    return doshaCode?.toLowerCase()?.split("")?.map(char => doshaMap[char] || "")?.filter(Boolean)?.join(" ");
  }

  const findDominantDosha = (prakritiState) => {
    if (prakritiState) {
      if (prakritiState.vata >= Math.max(prakritiState.pitta, prakritiState.kapha)) {
        // return ['Vata', "Dominant", `${prakritiState.vata.toFixed(0)}%`];
        return ['Vata'];
      } else if (prakritiState.pitta >= Math.max(prakritiState.vata, prakritiState.kapha)) {
        // return ['Pitta', "Dominant", `${prakritiState.pitta.toFixed(0)}%`];
        return ['Pitta'];
      } else {
        // return ['Kapha', "Dominant", `${prakritiState.kapha.toFixed(0)}%`];
        return ['Kapha'];
      }
    }
    return ['', "Dominant", , 0];
  };

  const scrollRef = useRef(null);
  const [centerIndex, setCenterIndex] = useState(0);
  const traits = positiveTraits?.split(",").map(t => t.trim()) || [];



  const IconsRepo = {
    Astringent: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Astringent.png",
    Bitter: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Bitter.png",
    Diet: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Diet.png",
    Pungent: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Pungent.png",
    Routine: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Routine.png",
    Salty: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Salty.png",
    Sour: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Sour.png",
    Sweet: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Sweet.png",
    Tips: "https://d2vx12jd8iaddd.cloudfront.net/icons/Prakriti+icons/Prakriti+icons/Tips.png"
  };

  function getImageForTaste(taste) {
    const key = taste?.trim()?.toLowerCase();

    switch (key) {
      case "sweet":
        return IconsRepo.Sweet;
      case "sour":
        return IconsRepo.Sour;
      case "salty":
        return IconsRepo.Salty;
      case "pungent":
        return IconsRepo.Pungent;
      case "bitter":
        return IconsRepo.Bitter;
      case "astringent":
        return IconsRepo.Astringent;
      default:
        return IconsRepo.Diet;
    }
  }

  const scrollToIndex = (index) => {
    const container = scrollRef.current;
    const items = container?.querySelectorAll(".scroll-item");
    if (!items || !items[index]) return;

    const targetItem = items[index];
    const offset = targetItem.offsetLeft - (container.offsetWidth - targetItem.offsetWidth) / 2;

    container.scrollTo({
      left: offset,
      behavior: "smooth",
    });

    setCenterIndex(index);
  };

  const autoScroll = () => {
    setCenterIndex((prev) => {
      const next = (prev + 1) % traits.length;
      scrollToIndex(next);
      return next;
    });
  };

  useEffect(() => {
    const interval = setInterval(autoScroll, 3000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (userDetails?.UID) {
      getAppointments(userDetails.UID);
    }
  }, [userDetails?.UID]);

  const hasNewAppointments = Appointments?.filter(e => e?.appointment_status === 'upcoming');

  useEffect(() => {
    if (!Appointments || Appointments.length === 0) return;

    const appointmentIdToUse = state?.appointmentid || hasNewAppointments?.[0]?.Appointment_id;

    if (appointmentIdToUse) {
      getAIReports(appointmentIdToUse);
    }

  }, [Appointments, state?.appointmentid]);

  const statuses = [
    { label: 'Book a Consultation', completed: hasNewAppointments?.length > 0 ? true : false },
    { label: 'Reports Uploaded', completed: AIReports?.length > 0 ? true : false },
    { label: 'Prakriti Assessment', completed: prakritiData ? true : false },
  ];

  const getStatusTag = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'low':
        return <span className="px-2 py-0.5 text-xs rounded bg-yellow-100 text-yellow-800 border border-yellow-300">Low</span>;
      case 'high':
        return <span className="px-2 py-0.5 text-xs rounded bg-red-100 text-red-800 border border-red-300">High</span>;
      case 'normal':
        return <span className="px-2 py-0.5 text-xs rounded bg-green-100 text-green-800 border border-green-300">Normal</span>;
      case 'missed':
        return <span className="px-2 py-0.5 text-xs rounded bg-gray-200 text-gray-600 border border-gray-300">Missed</span>;
      default:
        return <span className="px-2 py-0.5 text-xs rounded bg-gray-100 text-gray-700 border border-gray-200">Unknown</span>;
    }
  };

  const getIcon = (status) => {
    switch ((status || '').toLowerCase()) {
      case 'low':
      case 'high':
        return <AlertTriangle className="text-red-500 w-5 h-5 mr-2" />;
      case 'normal':
        return <CheckCircle className="text-green-500 w-5 h-5 mr-2" />;
    }
  };


  return <div className='Wellness-Info-section flex flex-col justify-center align-center overflow-y-hidden'>

    {isLoading ? (
      <div className='Prakriti-container flex flex-col items-center justify-center' style={{ height: "30rem", justifySelf: "center" }}>
        <Box sx={{ display: 'flex' }}>
          <CircularProgress style={{ color: "#DA6E0B" }} />
        </Box>
      </div>
    ) :
      (<div className='Prakriti-result-container mt-5 overflow-y-auto'>
        <div className='Prakriti-result-section'>

          <div className='flex flex-col items-center justify-center PreConsultationSummary-container'>

            <div className="mb-2 lock-img" >
              <img src={awlogo} alt="AW Logo" />
            </div>

            <div className='PreConsultationSummary-title'>
              <p>You’re All Set!</p>
            </div>

            <div style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400, textAlign: "center", marginBottom: "1rem" }}>
              <p>All steps complete—you're ready for your consultation!</p>
            </div>

            <div className="flex flex-col gap-4 w-full p-2 items-center justify-center" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400, textAlign: "center", }}>
              <div className="flex flex-col gap-4">
                {statuses.map((status, index) => (
                  <div
                    key={index}
                    className="flex items-center gap-4"
                  >
                    {status.completed ? (
                      <CheckCircle className="text-green-500 w-6 h-6" />
                    ) : (
                      <Circle className="text-gray-400 w-6 h-6" />
                    )}
                    <span className={`text-base ${status.completed ? 'text-gray-800' : 'text-gray-500'}`}>
                      {status.label}
                    </span>
                  </div>
                ))}
              </div>
            </div>

          </div>

          <div className="flex flex-col justify-between md:flex-row w-full h-full gap-4 px-4 py-2 flex-1 mt-5">


            <div className='Prakriti-result-item' style={{ height: "max-content" }}>
              <p>Prakriti Result</p>

              <div className="circleIndicatorContainer mt-5">
                <div style={{ position: 'relative', width: 250, height: 250 }}>
                  <CircularProgressbar
                    value={prakritiData?.vata}
                    className="first-circle"
                    strokeWidth={1}
                    styles={buildStyles({
                      pathColor: "#75623F",
                      trailColor: "transparent",
                      textColor: "#ffffff",
                    })}
                  />

                  <div style={{ position: 'absolute', top: '-5%', transform: 'translateY(-0%)', right: '50%', textAlign: 'right' }}>
                    <span className='prakritilabel'>Vata</span>
                  </div>

                  <div style={{ position: 'absolute', top: 10, left: 10, width: 230, height: 230 }}>
                    <CircularProgressbar
                      value={prakritiData?.pitta}
                      className="second-circle"
                      strokeWidth={1}
                      styles={buildStyles({
                        pathColor: "#FF5C00",
                        trailColor: "transparent",
                        textColor: "#ffffff",
                      })}
                    />
                  </div>

                  <div style={{ position: 'absolute', top: '-1%', transform: 'translateY(-0%)', right: '50%', textAlign: 'right' }}>
                    <span className='prakritilabel' >Pitta</span>
                  </div>

                  <div style={{ position: 'absolute', top: 20, left: 20, width: 210, height: 210 }}>
                    <CircularProgressbar
                      value={prakritiData?.kapha}
                      className="third-circle"
                      strokeWidth={1}
                      styles={buildStyles({
                        pathColor: "#6CBA6C",
                        trailColor: "transparent",
                        textColor: "#ffffff",
                      })}
                    />
                  </div>


                  <div style={{ position: 'absolute', top: '2%', transform: 'translateY(-0%)', right: '50%', textAlign: 'right', }}>
                    <span className='prakritilabel'>Kapha</span>
                  </div>

                  <div
                    className="inner-circle-content"
                    style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', textAlign: 'center' }}
                  >
                    <span className="inner-circle-text">
                      <div className="dominant-prakriti-doshas">
                        {/* {findDominantDosha(prakritiData).map((e) => {
                                                return <p key={e}>{e}</p>;
                                            })} */}

                        {/* <p>{.split('')?.join(' ')?.toUpperCase()}</p> */}
                        <p>{getDoshaName(prakritiData?.result)}</p>
                      </div>
                    </span>
                  </div>
                </div>

              </div>

              <div className='PrakritiPhenotype mt-5' >
                {/* <p>{prakritiData?.result?.split('')?.join(' ')?.toUpperCase()} Prakriti Characteristics</p> */}
                <p>{prakritiData?.result?.split('')?.join(' ')?.toUpperCase()} Prakriti</p>

              </div>


            </div>

            <div className="flex flex-col  w-full gap-4 px-4 flex-1 overflow-x-hidden">


              <div className="w-full flex flex-col md:flex-row justify-between gap-4">
                {/* Symptoms Box */}
                {vikritiData?.vikritiList?.length > 0 && (
                  <div
                    className="w-full md:w-1/2 bg-white border border-gray-300 rounded-lg shadow-sm p-4"
                    style={{ height: "max-content" }}
                  >
                    <p style={{ fontWeight: '600', fontSize: '16px', marginBottom: '0.75rem', fontFamily: "'Poppins', sans-serif" }}>
                      Symptoms
                    </p>
                    <ul style={{ paddingLeft: '1.5rem', margin: 0, listStyleType: 'disc' }}>
                      {vikritiData.vikritiList.map((item, index) => (
                        <li
                          key={index}
                          style={{
                            marginBottom: '0.5rem',
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: '14px',
                            color: '#3B362A'
                          }}
                        >
                          {item.symptoms}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {/* Diseases Box */}
                {diseases?.length > 0 && (
                  <div
                    className="w-full md:w-1/2 bg-white border border-gray-300 rounded-lg shadow-sm p-4"
                    style={{ height: "max-content" }}
                  >
                    <p style={{ fontWeight: '600', fontSize: '16px', marginBottom: '0.75rem', fontFamily: "'Poppins', sans-serif" }}>
                      Diseases
                    </p>
                    <ul style={{ paddingLeft: '1.5rem', margin: 0, listStyleType: 'disc' }}>
                      {diseases.map((item, index) => (
                        <li
                          key={index}
                          style={{
                            marginBottom: '0.5rem',
                            fontFamily: "'Poppins', sans-serif",
                            fontSize: '14px',
                            color: '#3B362A'
                          }}
                        >
                          {item.symptoms}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>

              {AIReports?.length > 0 &&
                <div className='w-full'>

                  <div className='flex gap-2 items-center' >
                    <img src={ReportIcon} alt="Report Icon" className="w-8 h-8" />
                    <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>Report Summary</p>
                  </div>

                  <div className="w-full mt-2">
                    {AIReports.map((reportItem, idx) => (
                      <Accordion key={idx} variant="separated">
                        {reportItem.Reports.map((report, i) => {
                          const aiAnalysis = report?.ai_analysis;

                          if (!aiAnalysis || aiAnalysis.includes('AI analysis failed') || aiAnalysis.trim() === '') return null;

                          let analysis;

                          try {
                            analysis = JSON.parse(aiAnalysis);
                          } catch (e) {
                            return null;
                          }

                          const abnormal = analysis.abnormal_parameters || [];

                          const normal = analysis.normal_parameters || [];

                          const combined = [
                            ...abnormal.map(p => ({ ...p, type: 'abnormal' })),
                            // ...normal.map(p => ({ ...p, type: 'normal' }))
                          ];

                          return combined.map((param, j) => {
                            const status = (param.status || '').toLowerCase();

                            return (
                              <Accordion.Item
                                key={j}
                                value={`${param.name}-${i}`}
                                style={{
                                  backgroundColor:
                                    status === 'low' || status === 'high'
                                      ? '#FFF5F5'
                                      : status === 'normal'
                                        ? '#F1EFEC'
                                        : '#F5F5F5',
                                  color: '#7C7870',
                                }}
                              >
                                <Accordion.Control style={{ display: 'flex', alignItems: 'center' }}>
                                  <div className='flex items-center gap-2 w-full' style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                                    {getIcon(status)}
                                    <div className="flex items-center justify-between gap-2 w-full">
                                      <div className='flex items-center gap-2'>
                                        <span style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>{param.name}</span>
                                        <p>({param?.value})</p>
                                      </div>

                                      {getStatusTag(status)}
                                    </div>
                                  </div>

                                </Accordion.Control>
                                <Accordion.Panel>
                                  <div className="text-sm text-gray-800" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                                    <p><strong>Reference Range:</strong> {param.reference_range}</p>
                                    {param.reason && <p className="mt-2 text-gray-600"><strong>Note:</strong> {param.reason}</p>}
                                  </div>
                                </Accordion.Panel>
                              </Accordion.Item>
                            );
                          });
                        })}
                      </Accordion>
                    ))}

                  </div>

                </div>
              }

              <div className='mt-5 w-full' onClick={() => {
                navigate('/')
              }} style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
                <img src={vikritinext} className='mt-5'></img>
              </div>

            </div>

            {/* <div className="flex flex-col md:flex-row w-full gap-4 px-4 py-2 flex-1 overflow-x-hidden">

                            <div className=" w-full lg:w-1/2 p-2">
                               
                                <div className="flex items-center justify-center gap-2 bg-[#8CEB8C] text-[#3B362A] rounded-md p-2 mb-2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                                    <img src={unqimage} className="w-5 h-5" alt="Unique" />
                                    <p>Unique Qualities</p>
                                </div>

                                <div
                                    ref={scrollRef}
                                    className="flex overflow-x-auto gap-4 p-2 scroll-smooth snap-x snap-mandatory scrollbar-hidden"
                                    style={{ scrollBehavior: "smooth", width: "100%" }}
                                >
                                    {traits.map((trait, index) => (
                                        <div
                                            key={index}
                                            className={`scroll-item flex-shrink-0 w-[220px] snap-center transition-all duration-300 py-2 px-4 rounded-md text-center whitespace-nowrap ${index === centerIndex
                                                    ? "bg-[#7FD67F] text-white scale-105 shadow-lg"
                                                    : "bg-gray-200 text-gray-700"
                                                }`}
                                            style={{
                                                fontFamily: "'Poppins', sans-serif",
                                                fontWeight: 400,
                                            }}
                                        >
                                            {trait?.charAt(0)?.toUpperCase() + trait?.slice(1)}
                                        </div>
                                    ))}
                                </div>

                                <div className="mt-5 bg-[#F2E9CE4D] rounded-md">
                                    <div className="text-center bg-[#F2E9CE] text-[#3B362A] rounded-t-md p-2" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                                        <p>TIPS TO STAY BALANCED</p>
                                    </div>
                                    <div className="mt-5 flex flex-col gap-4 p-5" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 400 }}>
                                        <div className="flex items-center gap-2">
                                            <img src={RoutineIcon} alt="Routine Icon" className="w-10 h-10" />
                                            <p>{routine}</p>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <img src={FoodIcon} alt="Food Icon" className="w-10 h-10" />
                                            <p>{food}</p>
                                        </div>
                                        <div className="flex items-center gap-2">
                                            <img src={tipsIcon} alt="Tips Icon" className="w-10 h-10" />
                                            <p>{techTip}</p>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>

                            <div className="w-full lg:w-1/2 p-2">
                                <div className="bg-[#F2E9CE4D] text-[#3B362A] rounded-md" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                                    <div className="text-center bg-[#F2E9CE] text-[#3B362A] rounded-t-md p-2 text-lg">
                                        Food Guide
                                    </div>

                                    {(suitable.length > 0 || avoid.length > 0) && (
                                        <div className="grid grid-cols-1 gap-4 text-center p-4 lg:grid-cols-2">
                                            <div>
                                                <div className="text-md font-bold mb-2 bg-[#75623F] rounded-t-md p-1 text-[#fdfdfd]" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                                                    Suitable
                                                </div>
                                                {suitable.map((taste, index) => (
                                                    <TasteItem
                                                        key={index}
                                                        taste={taste}
                                                        imageUrl={getImageForTaste(taste)}
                                                        bgColor="#8CEB8C4D"
                                                        iconColor="#75623F"
                                                    />
                                                ))}
                                            </div>

                                            <div>
                                                <div className="text-md font-bold mb-2 bg-[#75623F] rounded-t-md p-1 text-[#fdfdfd]" style={{ fontFamily: "'Poppins', sans-serif", fontWeight: 500 }}>
                                                    Minimize
                                                </div>
                                                {avoid.map((taste, index) => (
                                                    <TasteItem
                                                        key={index}
                                                        taste={taste}
                                                        imageUrl={getImageForTaste(taste)}
                                                        bgColor="#FFC7C7"
                                                        iconColor="#FD2121"
                                                    />
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                </div>

                                <div className="disorders-section mt-2">
                                    <BulletTextGrid textList={prakritiresultData?.diseases} />
                                </div>

                                <div className='mt-5' onClick={() => {
                                    navigate('/')
                                }} style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
                                    <img src={vikritinext} className='mt-5'></img>
                                </div>

                            </div>

                        </div> */}
          </div>

          {/* <div className='Skip-section block mt-5'
                        style={{ alignSelf: "flex-end", justifySelf: "flex-end", marginTop: 0, display: "block" }}>
                        <div className='flex items-center justify-center'>
                            <div style={{ width: "200px", }}>
                                <Button
                                    style={{
                                        width: '100%',
                                        textTransform: 'none',
                                        borderRadius: '0',
                                        backgroundColor: '#DA6E0B',
                                        color: 'white',
                                        border: 'none',
                                        boxSizing: 'border-box',
                                        borderRadius: '5px',
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                        padding: '10px'
                                    }}
                                    onClick={() => {
                                        navigate('/')
                                    }}
                                >
                                    Finish
                                </Button>
                            </div>
                        </div>
                    </div> */}

          {/* <div className='Prakriti-detail-item flex flex-col items-end h-full'> */}

          {/* <div className='PhenotypeChar' style={{ visibility: "hidden" }}>
                            <StrengthSlider dietList={prakritiresultData?.Strength}></StrengthSlider>
                            <WeaknessSlider dietList={prakritiresultData?.Weakness}></WeaknessSlider>
                        </div> */}





        </div>
      </div>
      )
    }

  </div>
};

export default PreConsultationSummary;
